import Icon from '../components/Icon.vue'

Icon.register({"laugh-squint":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM281.8 169.7L361.8 121.7C373.4 114.8 385.8 129.4 377.2 139.7L343.6 180 377.2 220.3C385.9 230.7 373.3 245.1 361.8 238.3L281.8 190.3C274.1 185.6 274.1 174.4 281.8 169.7zM118.8 139.7C110.2 129.4 122.6 114.8 134.2 121.7L214.2 169.7C222 174.4 222 185.6 214.2 190.3L134.2 238.3C122.7 245.1 110.2 230.7 118.8 220.3L152.4 180 118.8 139.7zM398.9 306C390 377 329.4 432 256 432H240C166.6 432 106 377 97.1 306 95.9 296.5 103.4 288 113 288H383C392.6 288 400.1 296.4 398.9 306z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/laugh-squint.js
// module id = null
// module chunks = 